<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}
.image_right {
  padding-bottom: 40px;
}




</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Self-Organised Spreads</p>
      </b-col>
    </b-row>



    <b-row class='content'>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Publication, self-organisation, collectives</p>
        <p>
          Self-Organised Spreads is a collection of interviews with seven collectives on the inner workings of their organisations.</p>
        <p>
          The publication is organised around several themes that arose from the conversations we had throughout the year. The voices of those in the collectives have been blended into one dialogue.</p>
          <p>The publication was developed in collaboration with amy pickles.</p>




      </div>
      </b-col>
      <b-col md="8">
        <b-row class="image_right">
          <b-col md="8" offset-md="2">
            <b-img class="img-fluid" src="media/spreads/spreads_printed_small.png"></b-img>

          </b-col>
        </b-row>
        <b-row class="image_right">

          <b-col md="4" offset-md="2">
            <b-img class="img-fluid" src="media/spreads/spreads_inside_smaller.png"></b-img>

          </b-col>
        
      <b-col md="4" offset-md="2">
        <b-img class="img-fluid" src="media/spreads/spreads_small.png"></b-img>

      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" offset-md="2">
      <b-img class="img-fluid" src="media/spreads/spreads_intro_smaller.png"></b-img>

      </b-col>
    </b-row>
    </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'Spreads',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
